import React from 'react';
import { IconArrowBackUp, IconArrowBackUpDouble, IconRotateDot } from '@tabler/icons-react';
import { TranscriptPauseEntry } from './types';

interface TranscriptPauseToolbarProps {
  entry: TranscriptPauseEntry;
  hasDelete: boolean;
  position: { top: number; left: number };
  onOptimize: () => void;
  onRecover: () => void;
  onOptimizeAll?: () => void;
  onRestoreAll?: () => void;
}

const TranscriptPauseToolbar = React.forwardRef<HTMLDivElement, TranscriptPauseToolbarProps>(
  ({ hasDelete, position, onOptimize, onRecover, onOptimizeAll, onRestoreAll }, ref) => {
    return (
      <div
        ref={ref}
        className="fixed z-[100] flex items-center gap-1 rounded-lg border border-slate-200 bg-white p-1.5 shadow-lg"
        style={{ top: position.top, left: position.left }}
      >
        {hasDelete ? (
          <>
            <button
              type="button"
              className="flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-slate-700 transition hover:bg-slate-100"
              onClick={onRecover}
            >
              <span>Restore</span>
            </button>
            {onRestoreAll && (
              <button
                type="button"
                className="flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-slate-700 transition hover:bg-slate-100"
                onClick={onRestoreAll}
              >
                <IconRotateDot className="size-4 rotate-180" />
                <span>Restore all</span>
              </button>
            )}
          </>
        ) : (
          <>
            <button
              type="button"
              className="flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-slate-700 transition hover:bg-slate-100"
              onClick={onOptimize}
            >
              <IconArrowBackUp className="size-4" />
              <span>Optimize</span>
            </button>
            {onOptimizeAll && (
              <button
                type="button"
                className="flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-slate-700 transition hover:bg-slate-100"
                onClick={onOptimizeAll}
              >
                <IconArrowBackUpDouble className="size-4" />
                <span>Optimize all</span>
              </button>
            )}
          </>
        )}
      </div>
    );
  }
);

TranscriptPauseToolbar.displayName = 'TranscriptPauseToolbar';

export default TranscriptPauseToolbar;
